import React from 'react'
import logUtil from 'utils/log'
import getIdCustomerUtil from 'utils/customer/get-id'
import useSelector from 'hooks/use-selector'
import isSummaryLoadedByMemberIdSelector from 'modules/squad/redux/selectors/is-summary-loaded-by-member-id'
import loadSummarySquadAction from 'modules/squad/redux/actions/load-summary'
import useDispatch from 'hooks/use-dispatch'
import SquadPageYouVeRatedSamplesAcrossOrdersEmpty from 'pages/Squad/containers/Friends/YouVeRatedSamplesAcrossOrders/Empty'
import SquadPageYouVeRatedSamplesAcrossOrdersContent from 'pages/Squad/containers/Friends/YouVeRatedSamplesAcrossOrders/Content'
import hasSurveyStatsByMemberIdSquadSelector from 'modules/squad/redux/selectors/has-survey-stats-by-member-id'

export default function SquadPageYouVeRatedSamplesAcrossOrders () {
  const dispatch = useDispatch()
  const customerId = getIdCustomerUtil()
  const isLoaded = useSelector(isSummaryLoadedByMemberIdSelector(customerId))
  const hasSurveyStats = useSelector(hasSurveyStatsByMemberIdSquadSelector(customerId))
  const debugProps = {
    isLoaded,
    customerId,
    hasSurveyStats
  }

  React.useEffect(() => {
    if (customerId && !isLoaded) {
      dispatch(
        loadSummarySquadAction({
          customerId
        })
      )
    }
  }, [customerId])

  logUtil('SquadPageYouVeRatedSamplesAcrossOrders').debug('debugProps=', debugProps)

  if (!isLoaded) {
    return <></>
  }

  if (!hasSurveyStats) {
    return (
      <SquadPageYouVeRatedSamplesAcrossOrdersEmpty />
    )
  }

  return (
    <SquadPageYouVeRatedSamplesAcrossOrdersContent />
  )
}
